var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandDefense(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 95,
    viewBox: "0 0 94 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.0007 92.0475C47.0007 92.0475 7.52073 73.8228 7.52073 17.0901C32.0792 11.6982 39.2965 2.38281 47.0007 2.38281C54.705 2.38281 61.9223 11.6982 86.4807 17.0901C86.4807 71.9428 47.0007 92.0475 47.0007 92.0475Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0007 13.1436C49.0121 13.2897 50.0774 13.6508 51.3074 14.2002C52.9684 14.9421 54.7975 15.9636 57.1482 17.1729C61.6844 19.5065 67.8289 22.3545 77.1951 24.4912C77.0065 45.4667 69.4067 59.8071 61.8318 68.9268C57.992 73.5496 54.1534 76.8359 51.281 78.9639C49.9457 79.953 48.8191 80.6898 48.0007 81.1943V13.1436Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandDefense);
export default __webpack_public_path__ + "static/media/brand-defense.31547808ed2d452801defb3776def88f.svg";
export { ForwardRef as ReactComponent };